import { adminConstants } from '../constants';
import { adminService, permissionService } from "../../services";
import { Cookies } from "react-cookie";
import { cookieConstants } from "../constants/";
import { unwrapList, unwrapResource } from '../../utils/apiList';

export const adminActions = {
  adminsList,
  addAdmin,
  getAdmin,
  updateAdmin,
  loadAcl,
};

const cookies = new Cookies();

function adminsList({ pageID, perPage, searchInput = '', role = 'all', orderBy = 'created_at', orderType = 'desc' }) {
  return dispatch => {
    dispatch(request());
    return adminService.adminsList({ pageID, perPage, searchInput, role, orderBy, orderType })
      .then(
        response => {
          const body = response.data.body || {};
          dispatch(success(unwrapList(body.admins), body.data ? body.data.total : 0));
        },
        error => {
          dispatch(failure(error));
        }
      );
  };

  function request() { return { type: adminConstants.GETALL_REQUEST } }
  function success(items, total) { return { type: adminConstants.GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: adminConstants.GETALL_FAILURE, error } }
}

function addAdmin(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return adminService.addAdmin(formData)
      .then(
        () => {
          addToast('عملیات با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          showError(addToast, error);
          dispatch(failure(error));
        }
      );
  };

  function request() { return { type: adminConstants.ADD_REQUEST } }
  function success(status) { return { type: adminConstants.ADD_SUCCESS, status } }
  function failure(error) { return { type: adminConstants.ADD_FAILURE, error } }
}

function getAdmin(adminID) {
  return dispatch => {
    dispatch(request());
    return adminService.getAdmin(adminID)
      .then(
        response => {
          dispatch(success(unwrapResource(response.data.body)));
        },
        error => {
          dispatch(failure(error));
        }
      );
  };

  function request() { return { type: adminConstants.GET_REQUEST } }
  function success(item) { return { type: adminConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: adminConstants.GET_FAILURE, error } }
}

function updateAdmin(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return adminService.updateAdmin(formData)
      .then(
        () => {
          addToast('بروزرسانی با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          showError(addToast, error);
          dispatch(failure(error));
        }
      );
  };

  function request() { return { type: adminConstants.UPDATE_REQUEST } }
  function success(status) { return { type: adminConstants.UPDATE_SUCCESS, status } }
  function failure(error) { return { type: adminConstants.UPDATE_FAILURE, error } }
}

function loadAcl() {
  return dispatch => {
    const user = cookies.get(cookieConstants.USER);
    if (!user || !user.role) {
      dispatch(ready(false, []));
      return;
    }
    if (user.role === 'super-admin') {
      dispatch(ready(true, []));
      return;
    }
    return permissionService.permissionShow(user.role)
      .then(
        result => {
          const actions = (result.rolePermissions || []).map(item => item.action).filter(Boolean);
          dispatch(ready(false, actions));
        },
        () => {
          dispatch(ready(false, []));
        }
      );
  };

  function ready(superAdmin, actions) {
    return { type: adminConstants.ACL_READY, superAdmin, actions };
  }
}

function showError(addToast, error) {
  if (typeof error === 'object' && error) {
    Object.keys(error).map(key => {
      const message = Array.isArray(error[key]) ? error[key][0] : error[key];
      addToast(message, { appearance: 'error', autoDismiss: true });
      return null;
    });
  } else {
    addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
  }
}
